import {
  SITEMAP_ROUTER_PATH,
  SITEMAP_JOB_TITLE_ROUTER_PATH,
  SITEMAP_JOB_TITLE_CITY_ROUTER_PATH,
  SITEMAP_JOB_RANKING_ROUTER_PATH,
  SITEMAP_JOB_RANKING_CITY_ROUTER_PATH,
  SITEMAP_CITY_ROUTER_PATH,
  SITEMAP_COMPANY_ROUTER_PATH,
  SITEMAP_ARTICLE_ROUTER_PATH,
} from '@/constants/router-path';

export const DEFAULT_PAGE = 1;

export const PAGE_SIZE_100 = 100;

export const PAGE_SIZE_200 = 200;

export const PAGE_SIZE_500 = 500;

export const PAGE_SIZE_1000 = 1000;

export const PAGE_SIZE_5000 = 5000;

export const SITEMAP_TABS = [
  {
    title: '地图首页',
    path: SITEMAP_ROUTER_PATH,
  },
  {
    title: '职场数据页',
    path: SITEMAP_JOB_TITLE_ROUTER_PATH,
  },
  {
    title: '城市职场数据页',
    path: SITEMAP_JOB_TITLE_CITY_ROUTER_PATH,
  },
  {
    title: '职场排名页',
    path: SITEMAP_JOB_RANKING_ROUTER_PATH,
  },
  {
    title: '城市职场排名页',
    path: SITEMAP_JOB_RANKING_CITY_ROUTER_PATH,
  },
  {
    title: '城市数据页',
    path: SITEMAP_CITY_ROUTER_PATH,
  },
  {
    title: '公司公开页',
    path: SITEMAP_COMPANY_ROUTER_PATH,
  },
  {
    title: '文章页',
    path: SITEMAP_ARTICLE_ROUTER_PATH,
  },
];
